import { render } from "./PaymentPurposeBadge.vue?vue&type=template&id=3160851d&scoped=true"
import script from "./PaymentPurposeBadge.vue?vue&type=script&lang=js"
export * from "./PaymentPurposeBadge.vue?vue&type=script&lang=js"

import "./PaymentPurposeBadge.vue?vue&type=style&index=0&id=3160851d&lang=stylus&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3160851d"]])

export default __exports__